import Navbar from "./Navbar";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import { Link } from "react-router-dom";
import logo from "../assets/logo/logol144.png";
import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { Button, colors, Stack, Typography } from "@mui/material";
import aicte from "../assets/logo/aicte.png";
import mudra from "../assets/logo/mudra.png";
import puneU from "../assets/logo/Pune-University.png";
import { Description, Login, LoginSharp } from "@mui/icons-material";
import LanguageIcon from "@mui/icons-material/Language";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const tickerLinks = [
  {
    text: "📢 BBA Institute Level / Against CAP Round Application Form",
    url: "https://forms.gle/7qiRfDLiR4UAE9s29",
  },
  {
    text: "🎓 Vruddhi Admission Portal",
    url: "https://mibm.vriddhionline.com/Login_1StudLogin_OCMS2.aspx",
  },
  {
    text: "💬 Admission Enquiry Form",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSefJkO8hsjXcobfxWUqsrRWeSnxk_hifZloabzxwwaFsPFoOQ/viewform",
  },
  // {
  //   text: "🔑 ERP Login",
  //   url: "https://mibm.cleverground.com/#/login",
  // },
];

export default function Header() {
  return (
    <>
      {/* <header>
        <Stack
          direction="row"
          mx={1}
          alignItems={"center"}
          justifyContent={"space-between"}
          my={4}
          width={"90vw"}
        >
          <div className="d-flex align-items-center vendor-name">
              <p className="m-0">PROGRESSIVE EDUCATION SOCIETY'S</p>
              <h5 className="m-0 fw-bold title-text">
                MODERN INSTITUTE OF BUSINESS MANAGEMENT
              </h5>
              <p className="m-0">
                (Approved by AICTE. New Delhi , Affiliated to Savitribai Phule
                Pune University)
              </p>
              <p className="m-0">NAAC Accredited</p>
            </div>
          </div>
          <Stack
            spacing={1}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Stack flexWrap={"nowrap"}>
              <Link
                className="AdmissionEnquiry btn"
                to="https://docs.google.com/forms/d/e/1FAIpQLSefJkO8hsjXcobfxWUqsrRWeSnxk_hifZloabzxwwaFsPFoOQ/viewform"
              >
                <WhatsAppIcon /> Admission Enquiry
              </Link>
            </Stack>
            <Stack flexWrap={"nowrap"}>
              <Link to="/Contact" className="btn contactBtn">
                <CallIcon /> Contact
              </Link>
            </Stack>
            {/* <Grid xs={2}  md={2}>
                  <Link to='https://mibm.akronsystems.com/pLogin.aspx' target='_blank' className='btn erpBtn'>ERP Login</Link>
                  </Grid> */}
      {/* </Stack>
        </Stack>

        <Navbar />
      </header> */}

      <header>
        <Grid
          container
          columns={{ xs: 1, md: 2 }}
          alignItems={"center"}
          justifyContent={"space-between"}
          my={{ xs: 1, md: 2 }}
          mx={1}
        >
          <Grid item xs={1} md={1.3}>
            <Stack direction={"row"} flexGrow={1}>
              <Box height={{ xs: "10vh", md: "15vh" }} m={"auto"}>
                <img
                  src={logo}
                  alt="logo"
                  style={{ margin: "auto" }}
                  height="100%"
                />
              </Box>
              <Box>
                <Stack
                  height={"100%"}
                  direction={"column"}
                  className="vendor-name"
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                >
                  <Typography variant="body2" color="text.secondary">
                    PROGRESSIVE EDUCATION SOCIETY'S
                  </Typography>
                  <Typography
                    color="customColors.clr1"
                    variant="h6"
                    className=" title-text"
                    sx={{ fontWeight: "bold", fontSize: "22px" }}
                  >
                    MODERN INSTITUTE OF BUSINESS MANAGEMENT
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    An Autonomous Institute Affiliated to Savitribai Phule Pune
                    University, Approved by AICTE. New Delhi.
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Grid>

          <Grid xs={12} md={0.7}>
            <Box
              display="flex"
              flexDirection={{ xs: "row", md: "column" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "flex-end" }}
              flexWrap={{ xs: "nowrap", md: "wrap" }}
              gap={{ xs: 2, md: 0 }}
              mt={1}
              width="100%"
            >
              {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  gap: 1,
                  mb: { xs: 0, md: 1 },
                }}
              >
                 <Link
                  to="https://forms.gle/M8PsQwD9G8fFMmUY6"

                >
                  <Description /> MBA Lateral Entry Application Form
                </Link>
                {[aicte, puneU, mudra].map((logo, i) => (
                  <img
                    key={i}
                    src={logo}
                    alt={`logo-${i}`}
                    height={60}
                    style={{
                      border: "1px solid gray",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      padding: "3px",
                      marginRight: "5px",
                      marginBottom:"3px"
                    }}
                  />
                ))}
              </Box> */}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" }, // column on mobile, row on desktop
                  justifyContent: "flex-start",
                  alignItems: { xs: "flex-start", md: "center" }, // better vertical alignment
                  gap: 1,
                  mb: { xs: 0, md: 1 },
                }}
              >
                <Link
                  className="MBALateralFrom btn"
                  // to="https://forms.gle/M8PsQwD9G8fFMmUY6"   //MBA Lateral Entry Application Form
                  // to="https://drive.google.com/file/d/1B46z3BVcO9DdyzV_rnVhdjmaFlP8qyp1/view?usp=drive_link"       // Lateral Admission Merit List
                  // to="https://forms.gle/B41d2QxeaTz1JBVDA"
                  to="https://forms.gle/7qiRfDLiR4UAE9s29"
                  target="_blank"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    // backgroundColor: "#1976d2",
                    color: "white",
                    textDecoration: "none",
                    padding: "6px 17px",
                    borderRadius: "4px",
                    height: "60px",
                    width: "200px", // 👈 keeps it as small as the content
                    fontWeight: "bold",
                    fontSize: "11px",
                  }}
                >
                  <Description /> BBA Institute Level/Against Cap Round
                  Application Form
                  {/* <Description /> Lateral Admission Merit List */}
                  {/* MBA Lateral Entry Application Form */}
                </Link>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {[aicte, puneU, mudra].map((logo, i) => (
                    <img
                      key={i}
                      src={logo}
                      alt={`logo-${i}`}
                      height={60}
                      style={{
                        border: "1px solid gray",
                        backgroundColor: "white",
                        borderRadius: "50%",
                        padding: "3px",
                        marginRight: "5px",
                        marginBottom: "3px",
                      }}
                    />
                  ))}
                </Box>
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                  gap: 1,
                  width: { xs: "100%", md: "auto" },
                  ml: { xs: "auto", md: 0 },
                }}
              >
                <Link
                  className="AdmissionEnquiry btn"
                  to="https://docs.google.com/forms/d/e/1FAIpQLSefJkO8hsjXcobfxWUqsrRWeSnxk_hifZloabzxwwaFsPFoOQ/viewform"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0",
                    gap: "5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <WhatsAppIcon fontSize="small" /> Admission Enquiry
                </Link>

                <Link
                  className="AdmissionEnquiry btn"
                  to="https://mibm.vriddhionline.com/Login_1StudLogin_OCMS2.aspx"
                  target="_blank"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: 0,
                    justifyContent: "center",
                    gap: "5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <LanguageIcon fontSize="small" /> Vruddhi Admission Portal
                </Link>

                <Link
                  to="/Contact"
                  className="btn contactBtn"
                  style={{
                    display: "flex",
                    margin: 0,
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <CallIcon fontSize="small" /> Contact
                </Link>

                <Link
                  to="https://mibm.cleverground.com/#/login"
                  target="_blank"
                  className="btn erpBtn"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#A70606",
                    margin: 0,
                    border: "none",
                    color: "#A70606",
                    gap: "3px",
                    color: "white",
                  }}
                >
                  <Login sx={{ color: "white" }} /> Login
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>
      {/*  <Box
          sx={{
            bgcolor: "#FFF8E1",
            overflow: "hidden",
            whiteSpace: "nowrap",
            py: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "max-content",
              animation: "ticker 20s linear infinite",

              "@keyframes ticker": {
                from: {
                  transform: "translateX(0)",
                },
                to: {
                  transform: "translateX(-50%)",
                },
              },

              "&:hover": {
                animationPlayState: "paused",
              },
            }}
          >
            {[...tickerLinks, ...tickerLinks].map((item, index) => (
              <Link
                key={index}
                to={item.url}
                target="_blank"
                style={{
                  color: "#8B0000",
                  textDecoration: "none",
                  fontWeight: 600,
                  marginRight: "70px",
                  display: "inline-flex",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                {item.text}
              </Link>
            ))}
          </Box>
        </Box>*/}
        <Navbar />
      </header>
    </>
  );
}
